// extracted by mini-css-extract-plugin
export default {"bg":"Btn_bg__3EDEn","wrap":"Btn_wrap__7FWTZ","wrap_main":"Btn_wrap_main__953ak"};